import { HttpHeaders } from "@angular/common/http";
import * as XLSX from 'xlsx';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { FormGroup } from "@angular/forms";

type TableField = {
  header: string;
  width: string;
  field: string;
  align: string;
};

// src/app/shared/body-objects.ts
export interface AgentsBody {
  title: string;
  tableFields: TableField[];
  tableHistorique: TableField[];
  tableObjectif: TableField[];
  tabs: any[];
  ICpage: any;
  AMpage: any;
  OEpage: any;
  synthese_globale: any;
  evaluateur: any;
  approbateur: any;
  checkValue: any;
  synthese_evaluation: any;
  synthese_valeur: any;
  resultat_global: any;
  resulEvaluation: any[];
  evaluation: any;
  listSG: any;
  listFC: any;
  listCIE: any;
  listPI: any;
  listRH: any;
  listVE: any;
  response: any[];
  listIC: any[];
  listAM: any[];
  listOE: any[];
  listCompetence: any[];
  listHistorique: any[];
  listSituation: any[];
  listPopulation: any[];
  listCatalogue: any[];
  listType: any[];
  listStatutAG: any[];
  listStatutM: any[];
  listSexe: any[];
  listStructure: any[];
  listPriorite: any[];
  listClassification: any[];
  listCategorie: any[];
  listEmploi: any[];
  listBudget: any[];
  listTypeContrat: any[];
  listDR: any[];
  listDomaine: any[];
  listPoste: any[];
  listObjectif: any[];
  listTypeFormation: any[];
  listFormation: any[];
  listLieu: any[];
  transformedSuivi: any[];
  _agent: any;
  _type: any;
  _direction: any;
  _structure: any;
  type_formation: any;
  domaine_formation: any;
  formations_id: any;
  _classification: any;
  nom_prenoms: string;
  code_competence: string;
  matricule: string;
  commentaire: string;
  errorMessage: string | null;
  campagne_id: any;
  agentArray: any[];
  myForm: any;
  isLoading: boolean;
  agentForm: FormGroup;
  catalogueForm: FormGroup;
  dataLoaded: boolean;
  anneeDataLoaded: boolean;
  typeDataLoaded: boolean;
  domaineDataLoaded: boolean;
  directionDataLoaded: boolean;
  classificationDataLoaded: boolean;
  categorieDataLoaded: boolean;
  structureDataLoaded: boolean;
  submitted: boolean;
  dataLength: any;
  showContent: boolean;
  clickEventSubscription: Subscription;
  offset: any;
  totalPage: number;
  totalRecords: number;
  recordsPerPage: number;
  p: number;
  soldes: any;
  activeTab: any;
  objectRow: any;
  activeId: number;
  listAgents: any[];
  filter: string;
  annee: string;
  date: string;
  statutFiche: any;
}

export const bodyObjects: { agents: AgentsBody } = {
  agents: {
    title: 'Liste des agents',
    tableFields: [
      { header: '#', width: '3px', field: 'index', align: 'center' },
      { header: 'Mle', width: '1%', field: 'matricule', align: 'center' },
      { header: 'Nom & Prénoms', width: 'auto', field: 'nomPrenoms', align: 'left' },
      { header: 'Cat.', width: 'auto', field: 'categorie', align: 'center' },
      { header: 'Anc.Cat.', width: 'auto', field: 'anciennete_cat', align: 'center' },
      { header: 'Sexe', width: 'auto', field: 'sexe', align: 'center' },
      { header: 'Class.', width: 'auto', field: 'classification', align: 'center' },
      { header: 'Type contrat', width: 'auto', field: 'type_contrat', align: 'left' },
      { header: 'Poste', width: 'auto', field: 'poste', align: 'left' },
      { header: 'Structure', width: 'auto', field: 'structure', align: 'left' },
      { header: 'Cas Rh', width: 'auto', field: 'cas_rh', align: 'left' },
      { header: 'Actions', width: '8.5%', field: 'actions', align: 'center' }
    ],
    tableHistorique : [
      { header: '#', width: '1%', field: 'index', align: 'center'},
      { header: 'Date', width: 'auto', field: 'created_at', align: 'center'},
      { header: 'Opération', width: 'auto', field: 'sous_module', align: 'center'},
      { header: 'Détails opération', width: 'auto', field: 'action', align: 'center'},
      { header: 'Source [Utilisateur]', width: '1auto', field: 'nom_prenoms', align: 'center'},
      { header: 'Actions', width: '5%', field: 'actions', align: 'center'},
    ],
    tableObjectif: [
      { header: '#', width: '1%', field: 'index', align: 'center' },
      { header: `Description de l'objectif`, width: '60%', field: 'description', align: 'left' },
      { header: `Délais`, width: 'auto', field: 'delai', align: 'left' },
      { header: `Indicateurs`, width: 'auto', field: 'indicateur', align: 'left' },
      { header: 'Actions', width: 'auto', field: 'actions', align: 'left' }
    ],
    tabs: [
      { title: 'Objectifs EIA A+1', subtitle: 'Liste des objectifs EIA A+1', annee: 'A+1' },
      { title: 'Objectifs EIA A-1', subtitle: 'Liste des objectifs EIA A-1', annee: 'A-1' },
      { title: `OBJ. EN COURS D'ANNEE`, subtitle: `Liste des objectifs EIA en cours d'année`, annee: 'A' }
    ],
    ICpage: null,
    AMpage: null,
    OEpage: null,
    synthese_globale: null,
    evaluateur: null,
    approbateur: null,
    checkValue: null,
    synthese_evaluation: null,
    synthese_valeur: null,
    resultat_global: null,
    resulEvaluation: [],
    evaluation: null,
    listSG: null,
    listFC: null,
    listCIE: null,
    listPI: null,
    listRH: null,
    listVE: null,
    response: [],
    dataLength: 0,
    listCompetence: [],
    listObjectif: [],
    listFormation: [],
    listCatalogue: [],
    listDomaine: [],
    listIC: [],
    listAM: [],
    listOE: [],
    listEmploi: [],
    listPoste: [],
    listDR: [],
    listAgents: [],
    listTypeFormation: [],
    listStructure: [],
    listCategorie: [],
    listClassification: [],
    listHistorique: [],
    listTypeContrat: [],
    listPriorite : [{ 'label': '1', 'value': 1 }, { 'label': '2', 'value': 2 }],
    listLieu : [{ 'label': 'SIR', 'value': 'SIR' }, { 'label': 'HORS SIR', 'value': 'HORS SIR' }, { 'label': 'HORS CI', 'value': 'HORS CI' }],
    listBudget : [{ 'label': 'IMPUTATION', 'value': 'imputation' }, { 'label': 'AUTRE', 'value': 'autre' }],
    listSituation: [{ 'libelle': 'Célibataire', 'code': 'C' }, { 'libelle': 'Marié(e)', 'code': 'M' }, { 'libelle': 'Divorcé(e)', 'code': 'D' }, { 'libelle': 'Veuf(ve)', 'code': 'V' }],
    listPopulation: [{ 'libelle': 'Personnel', 'code': 'personnel' }, { 'libelle': 'Direction', 'code': 'direction' }, { 'libelle': 'Projet', 'code': 'projet' }, { 'libelle': 'CPS', 'code': 'cps' }],
    listType: [{ 'libelle': 'SIR', 'code': 'sir' }, { 'libelle': 'SMB', 'code': 'smb' }],
    listStatutAG: [{ 'libelle': 'Actif', 'code': 'actif' }, { 'libelle': 'Sorti', 'code': 'sorti' }, { 'libelle': 'Nouveau', 'code': 'nouveau' }],
    listStatutM: [{ 'libelle': 'Oui', 'code': true }, { 'libelle': 'Non', 'code': false }],
    listSexe: [{ 'libelle': 'M', 'code': 'M' }, { 'libelle': 'F', 'code': 'F' }],
    transformedSuivi: [],
    agentArray: [],
    soldes: null,
    _type: null,
    annee: null,
    date: null,
    code_competence: null,
    _agent: null,
    _direction: null,
    _structure: null,
    _classification: null,
    type_formation: null,
    domaine_formation: null,
    formations_id: null,
    errorMessage: null,
    nom_prenoms: '',
    matricule: '',
    commentaire: '',
    campagne_id: null,
    agentForm: null,
    catalogueForm: null,
    objectRow: null,
    myForm: null,
    isLoading: false,
    dataLoaded: false,
    domaineDataLoaded: false,
    directionDataLoaded: false,
    classificationDataLoaded: false,
    categorieDataLoaded: false,
    anneeDataLoaded: false,
    typeDataLoaded: false,
    structureDataLoaded: false,
    submitted: false,
    clickEventSubscription: null,
    showContent: true,
    offset: null,
    totalPage: 0,
    totalRecords: 0,
    recordsPerPage: 0,
    p: 1,
    activeTab: null,
    activeId: 1,
    filter: '',
    statutFiche: null
  }
};

export function getStatusClasses(statut: string): { [key: string]: boolean } {
  return {
    'badge-info': statut === 'initialisée' || statut === 'soumis' || statut === 'appliquée' || statut === 'analysée',
    'badge-danger': statut === 'non-initié' || statut === 'archivée' || statut === 'retournée' || statut === 'inactif',
    'badge-success': statut === 'initié' || statut === 'arbitrée' || statut === 'traitée' || statut === 'actif',
    'badge-warning': statut === 'en attente',
    'badge-demarre': statut === 'démarrée',
    'badge-valide': statut === 'validée',
    'badge-effectue': statut === 'effectuée' || statut === 'démarrée',
    'badge-accepte': statut === 'acceptée',
    'badge-planifie': statut === 'planifiée',
    'badge-approuve': statut === 'approuvée',
    'badge-revus': statut === 'revu',
    'badge-soumis': statut === 'soumis',
    'badge-100': statut !== 'planifiée'
  };
}

export function getDisplayStatut(statut: string): string {
  return statut === 'en attente' ? statut : `${statut}e`;
}


export function getHeaders(accessToken: string): HttpHeaders {
  return new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
    'Access-Control-Allow-Origin': '*',
    'Authorization': `Bearer ${accessToken}`
  });
}

export function getStructure(service, direction_id: number): any {
  return service.getData(`capital-humain/structures/${direction_id}/structure-of-direction`)
}

// ... (rest of your existing code in bodyObjects.ts)

export function onFileChange(ev: any, formGroup: any, setAgentArray: (data: any) => void) {
  let workBook = null;
  let jsonData = null;
  const reader = new FileReader();
  const file = ev.target.files[0];
  reader.onload = (event) => {
    formGroup.patchValue({
      file: reader.result
    });
    const data = reader.result;
    workBook = XLSX.read(data, { type: 'binary' });
    jsonData = workBook.SheetNames.reduce((initial, name) => {
      const sheet = workBook.Sheets[name];
      initial[name] = XLSX.utils.sheet_to_json(sheet);
      return initial;
    }, {});
    const dataString = JSON.stringify(jsonData);
    const dataStringParse = JSON.parse(dataString);
    setAgentArray(dataStringParse);
  }
  reader.readAsBinaryString(file);
}

export function addBulkAgents(content: any, modalService: NgbModal): NgbModalRef {
  return modalService.open(content, {
    ariaLabelledBy: 'modal-basic-title',
    backdrop: 'static',
    keyboard: false,
    centered: true
  });
}

export function onSubmit(formGroup: any, bodyObject: any, saveAllAgents: () => void) {
  bodyObject.submitted = true;
  // stop here if form is invalid
  if (formGroup.invalid) {
    return;
  }
  saveAllAgents();
}

export function prepareAgentData(data: any) {
  return data;
}

export function saveAgents(
  service: any,
  data: any,
  loadingBar: any,
  url: any
): Observable<any> {
  loadingBar.start();
  return service.postData(url, data);
}

export function handleSaveAgentsResponse(
  res: any,
  loadingBar: any,
  activeModal: any,
  excelService: any,
  swal: any
) {
  loadingBar.stop();
  activeModal.close();
  if (res.error === false) {
    try {
      excelService.exportAsExcelFile(res.data, 'Rapport sauvegarde des agents');
    } catch (error) {
    }

    swal.fire({
      title: 'PVCH DIGITAL',
      text: res.message,
      icon: 'success',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok'
    });
  } else {
    swal.fire('PVCH DIGITAL', res.message, 'error');
  }
}

export function handleSaveAgentsError(
  err: any,
  loadingBar: any,
  toastrService: any
) {
  loadingBar.stop();
  toastrService.error(err.error.message);
}


export function clearValue(bodyObject: any) {
  bodyObject._direction = "";
  bodyObject._structure = "";
  bodyObject._classification = "";
  bodyObject.nom_prenoms = "";
  bodyObject.matricule = "";
  bodyObject.code_competence = "";
  bodyObject.type_formation = "";
  bodyObject.domaine_formation = "";
  bodyObject.formations_id = "";
}
